import React, { useContext } from 'react';
import "./QuestionAnswers.scss";
import { ConfigurationContext } from '../../Context/Configuration';
import FormTemplate from '../Contest/FormTemplate';
import { Redirect } from 'react-router';

const Results = () => {
  const [config, update] = useContext(ConfigurationContext);
  const correctAns = config.questions.filter(a => a["selectedAnswer"]["isCorrect"]).length;
  const btnStyles = {
    padding: "10px",
    color: "#ffffff",
    backgroundColor: "#00acee"
  };

  if (correctAns >= 4) {
    return (
        <FormTemplate />
    );
  }else {
    if(config.restartQuiz)
    {
      update({...config, restartQuiz:false})
      return (
        <Redirect to='/entercontest'/>
      );
    }
    else
    return ("");
  }
  
};

export default Results;